import { useMemo } from 'react';
import { Field, FieldTypes } from '@common-fe/common-fe';
import { toNumber } from 'lodash';

import { EMPTY_FIELD_VALUE } from '@/common/constants';
import useLockboxDetailsStore from '@/modules/employer/components/Lockbox/LockboxDetails/stores/useLockboxDetails.store';
import { formatCurrency } from '@/utils';

const useLockboxClaimRepaymentFields = () => {
  const { originalLockbox } = useLockboxDetailsStore();
  const claimIds = originalLockbox?.ocr?.claimIds;

  const lockboxClaimRepaymentFields = useMemo(() => [
    {
      type: FieldTypes.Text,
      name: 'employee',
      label: 'Employee name',
      value: originalLockbox?.ocr?.employeeName || EMPTY_FIELD_VALUE,
    },
    {
      type: FieldTypes.Text,
      name: 'claimNumber',
      label: 'Claim number',
      value: claimIds?.length
        ? claimIds?.join(', ')
        : EMPTY_FIELD_VALUE,
    },
    {
      type: FieldTypes.Text,
      name: 'amount',
      label: 'Amount',
      value: originalLockbox?.amount
        ? formatCurrency(toNumber(originalLockbox?.amount))
        : EMPTY_FIELD_VALUE,
    },
  ], [originalLockbox, claimIds]);

  return {
    lockboxClaimRepaymentFields: lockboxClaimRepaymentFields as Field[],
  };
};

export default useLockboxClaimRepaymentFields;
